import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Breadcrumb, Input, CustomSelect } from '../../common/components';
import { getWarrantyOptionDict, saveWarrantyOptionDict, getCompanyGroups } from '../services/dictionary.service';


const getOptionLabel = (option) => option.name;

const getOptionValue = (option) => option.id;
class DictWarrantyOptionForm extends PureComponent {
  state = {
    name: '',
    price: 0,
    year_limit: undefined,
    mileage_limit: undefined,
    engine_limit: undefined,
    active: true,
    actualPrice: 0,
    group: null,
    companyGroups: [],
  };

  id = this.props.match.params.id;

  itemId = this.props.match.params.itemId;

  warrantyId = this.props.match.params.warrantyId;

  async componentDidMount() {
    if (this.itemId) {
      const detailsData = await getWarrantyOptionDict(this.itemId);
      const { data: companyGroups } = await getCompanyGroups();

      this.setState({
        ...detailsData,
        isLoading: false,
        companyGroups,
      });
    } else {
      const { data: companyGroups } = await getCompanyGroups();

      this.setState({
        isLoading: false,
        companyGroups,
      });
    }
  }

  onInputChange = (name, value) => this.setState({ [name]: value });

  onCompanyGroupChange = (_, companyGroup) => {
    this.setState({
      group: companyGroup,
    });
  }

  handleSave = async () => {
    try {
      await saveWarrantyOptionDict(Object.assign(this.state, {
        dictWarrantyType: this.warrantyId ? this.warrantyId : this.id,
      }));

      this.props.history.goBack();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const {
      name,
      price,
      year_limit,
      mileage_limit,
      engine_limit,
      active,
      actualPrice,
      group,
      companyGroups,
    } = this.state;

    const { match: { params } } = this.props;
    const title = params.itemId ? 'Edycja opcji gwarancji' : 'Dodawanie nowej opcji gwarancji';

    return (
      <>
        <Breadcrumb title={title} />
        <div className="content">
          <div className="card">
            <div className="card-body card-block">
              <div className="form-horizontal">
                <Input
                  id="name"
                  label="Nazwa opcji"
                  value={name}
                  onChange={this.onInputChange}
                  horizontal
                />
                <Input
                  id="price"
                  label="Cena opcji"
                  value={price}
                  onChange={this.onInputChange}
                  horizontal
                />
                <Input
                  id="actualPrice"
                  label="Rzeczywista cena opcji"
                  value={actualPrice}
                  onChange={this.onInputChange}
                  horizontal
                />
                <Input
                  id="year_limit"
                  label="Limit wieku samochodu [w latach]"
                  value={year_limit}
                  onChange={this.onInputChange}
                  horizontal
                />
                <Input
                  id="mileage_limit"
                  label="Limit przebiegu [w km]"
                  value={mileage_limit}
                  onChange={this.onInputChange}
                  horizontal
                />
                <Input
                  id="engine_limit"
                  label="Limit pojemności [w cm3]"
                  value={engine_limit}
                  onChange={this.onInputChange}
                  horizontal
                />
                <Input
                  id="active"
                  label="Aktywna"
                  value={active}
                  onChange={this.onInputChange}
                  type="checkbox"
                  horizontal
                />
                <CustomSelect
                  label="Grupy klientów"
                  data={{ id: 'companyGroup' }}
                  value={group}
                  onChange={this.onCompanyGroupChange}
                  options={companyGroups}
                  getOptionValue={getOptionValue}
                  getOptionLabel={getOptionLabel}
                  horizontal
                />
              </div>
            </div>
          </div>
          <div className="form-group float-right">
            <button
              type="button"
              onClick={this.handleSave}
              className="btn btn-primary btn-sm"
            >
              <i className="fa fa-dot-circle-o" />
              {' '}
              Zapisz
            </button>
          </div>
        </div>
      </>
    );
  }
}

DictWarrantyOptionForm.defaultProps = {};

DictWarrantyOptionForm.propTypes = {
  match: PropTypes.objectOf(PropTypes.shape).isRequired,
  history: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default withRouter(DictWarrantyOptionForm);
